<template>
    <article id="home">
        <Banner/>
        <Osvdm/>
        <Sobre/>
        <Especial/>
        <Lote/>
        <Bailes/>
        <Equipe/>
        <h1>Home</h1>
        <Parallax/>
    </article>
</template>

<script>
import Banner from './components/Banner'
import Osvdm from './components/Osvdm'
import Sobre from './components/Sobre'
import Especial from './components/Especial'
import Lote from './components/Lote'
import Bailes from './components/Bailes'
import Equipe from './components/Equipe'
import Parallax from './components/Parallax'

export default {
    name: 'Home',
    components: {
        Banner,
        Osvdm,
        Sobre,
        Especial,
        Lote,
        Bailes,
        Equipe,
        Parallax
    }
}
</script>

<style lang="sass">
</style>
